import React from 'react';
import 'twin.macro';
import { useNavigate } from 'react-router-dom';
import { ToolbarStructure } from '@teetsh/app/src/components/Layouts/ToolbarStructure';
import { EdtToolbarLeft } from './components/EdtToolbarLeft';
import { EdtToolbarCenter } from './components/EdtToolbarCenter';
import { EdtToolbarActions } from './components/EdtToolbarActions';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';

interface EdtToolbarProps {
  edtId: string;
  emploiDuTempsName: string;
  emploiDuTempsSubtitle: string;
  isReadOnly?: boolean;
  onDuplicateShareEDT?: () => void;
  onOpenDrawer?: (view: string) => void;
  displayedClassrooms?: string[];
  emploiDuTemps?: any;
  isGuest?: boolean;
  date: Date;
}

export function EdtToolbar({
  edtId,
  emploiDuTempsName,
  emploiDuTempsSubtitle,
  isReadOnly,
  onDuplicateShareEDT,
  onOpenDrawer,
  displayedClassrooms,
  emploiDuTemps,
  isGuest,
  date,
}: EdtToolbarProps) {
  const navigate = useNavigate();
  const { school, schoolyear } = useSchoolSchoolyear();

  const handleBackClick = () => {
    navigate(
      `/annee-scolaire/${schoolyear.id}/ecole/${school.id}/emploi-du-temps`,
    );
  };

  return (
    <ToolbarStructure
      tw="border-0"
      breakpoint="2xl"
      sideColumnWidth="18rem"
      showBackButton={!isGuest}
      onBackClick={handleBackClick}
    >
      <EdtToolbarLeft onDuplicateShareEDT={onDuplicateShareEDT} />
      <EdtToolbarCenter
        edtId={edtId}
        name={emploiDuTempsName}
        subtitle={emploiDuTempsSubtitle}
        isReadOnly={isReadOnly}
      />
      <EdtToolbarActions
        date={date}
        edtId={edtId}
        isReadOnly={isReadOnly}
        onOpenDrawer={onOpenDrawer}
        displayedClassrooms={displayedClassrooms}
        emploiDuTemps={emploiDuTemps}
        isGuest={isGuest}
      />
    </ToolbarStructure>
  );
}
